<template>
  <ag-grid-vue
    ref="dataGridLog"
    theme="legacy"
    :rowData="activityLogEntries"
    :columnDefs="colDefsLog"
    :defaultColDef="defaultColDefsLog"
    :autoSizeStrategy="{ type: 'fitGridWidth' }"
    suppressCellFocus
    :class="darkVal ? 'ag-theme-quartz-dark' : 'ag-theme-quartz'"
    @grid-size-changed="resizeLog"
  ></ag-grid-vue>
</template>

<script setup lang="ts">
import { AgGridVue } from "ag-grid-vue3";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { usePropsStore } from "@/stores/props";
import type { CorrespondenceEntry } from "@/types/ActivityLog";
import { computed, ref } from "vue";

const dataGridLog = ref();
const activityLogEntries = defineModel<CorrespondenceEntry[]>("activityLogEntries", { required: true });
const propsStore = usePropsStore();
const darkVal = computed<boolean>(() => propsStore.darkMode);

const resizeLog = (): void => {
  dataGridLog.value.api.sizeColumnsToFit();
};

const defaultColDefsLog = {
  filter: true,
  floatingFilter: false,
  cellDataType: "text",
  editable: true,
};

const colDefsLog = ref([
  {
    field: "date",
    headerName: "Date",
    cellDataType: "text",
    minWidth: 200,
    maxWidth: 200,
  },
  {
    field: "description",
    headerName: "Description",
    cellDataType: "text",
  },
]);
</script>
